import { useMemo } from 'react';
import { Row } from '@tanstack/react-table';
import { VirtualItem } from '@tanstack/react-virtual';

type UseVisibleRowsParams<TData> = {
  rows: Array<Row<TData>>;
  virtualRows: Array<VirtualItem>;
  isVirtualized?: boolean;
};

export const useVisibleRows = <TData>({
  rows,
  virtualRows,
  isVirtualized = false,
}: UseVisibleRowsParams<TData>): Array<Row<TData>> => {
  return useMemo(() => {
    if (!isVirtualized) {
      return rows;
    }

    if (virtualRows.length === 0) {
      return [];
    }

    const startIndex = virtualRows[0].index;
    const endIndex = virtualRows[virtualRows.length - 1].index + 1;

    return rows.slice(startIndex, endIndex);
  }, [rows, virtualRows, isVirtualized]);
};
